import { setGameHole } from './ggGamesData.js'

// Bingo-Bango-Bongo per-hole panel — mirrors the app's 3 award buttons:
// Bingo (first on green), Bango (closest once all on), Bongo (first in hole).
// Tap a player for each award → writes ggGames/{id}/bbb/{hole} = {bingo,bango,bongo}.
const AWARDS = [
  ['bingo', '🏌️ Bingo', 'first on the green'],
  ['bango', '📍 Bango', 'closest once all on'],
  ['bongo', '🕳️ Bongo', 'first in the hole'],
]

export default function GBbbHoleInputs({ gameId, game, hole }) {
  const players = game.players || []
  const cur = game.bbb?.[hole] || {}
  const pick = (award, pid) => setGameHole(gameId, 'bbb', hole, { ...cur, [award]: cur[award] === pid ? null : pid })
  return (
    <div style={{ border: '1px solid #E5E7EB', borderRadius: 12, padding: 10, marginBottom: 10, background: '#FBFBF7' }}>
      {AWARDS.map(([key, label, hint]) => (
        <div key={key} style={{ marginBottom: 8 }}>
          <div style={{ fontWeight: 700, fontSize: 13 }}>{label} <span style={{ color: '#888', fontWeight: 400 }}>· {hint}</span></div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
            {players.map((p) => {
              const on = cur[key] === p.id
              return (
                <button key={p.id} onClick={() => pick(key, p.id)} style={{
                  padding: '5px 12px', borderRadius: 999, fontSize: 13, fontWeight: 700, cursor: 'pointer',
                  border: `1px solid ${on ? '#1B7A3E' : '#ccc'}`, background: on ? '#1B7A3E' : '#fff', color: on ? '#fff' : '#333',
                }}>{p.name.split(' ')[0]}</button>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
